import {manualPlayerDraft} from "./manualPlayerFields";

export const PLAYER_COLUMNS=[["photoReference","Image #"],["firstName","First Name"],["lastName","Last Name"],["jersey","Jersey #"],["graduationYear","Graduation year"],["notes","Notes"]];
const playerCollator=new Intl.Collator("en",{numeric:true,sensitivity:"base"});
export function sortPlayerRows(items,sort) {
  if(!PLAYER_COLUMNS.some(([field])=>field===sort?.field))return items.slice();
  const direction=sort.direction==="desc" ? -1 : 1;
  return items.map((item,index)=>({item,index,value:String(manualPlayerDraft(item)[sort.field] || "").trim()})).sort((a,b)=>{
    if(!a.value || !b.value)return a.value ? -1 : b.value ? 1 : a.index-b.index;
    return direction*playerCollator.compare(a.value,b.value) || a.index-b.index;
  }).map(row=>row.item);
}
export function manualSeniorRows(items,olderIds=[]) {
  const selected=new Set(olderIds);
  return items.filter(item=>item.kind==="senior" && (item.entrySource==="manual" || (item.entrySource==null && selected.has(item.id))));
}
function cell(value) {
  let text=String(value ?? "");
  if(/^[=+\-@]/.test(text.trimStart()) || /^[\t\r]/.test(text))text="'"+text;
  return '"'+text.replace(/"/g,'""')+'"';
}
function playerRowsCSV(items) {
  const rows=[PLAYER_COLUMNS.map(([,label])=>label),...items.map(item=>{const fields=manualPlayerDraft(item);return PLAYER_COLUMNS.map(([field])=>fields[field]);})];
  return "\uFEFF"+rows.map(row=>row.map(cell).join(",")).join("\r\n");
}
export const manualSeniorsCSV=(items,olderIds=[])=>playerRowsCSV(manualSeniorRows(items,olderIds));
export const allSeniorsCSV=items=>playerRowsCSV(items.filter(item=>item.kind==="senior"));
function downloadCSV(contents,label,suffix) {
  const url=URL.createObjectURL(new Blob([contents],{type:"text/csv;charset=utf-8"}));
  const link=document.createElement("a");link.href=url;link.download=String(label || "banner-job").replace(/[^a-z0-9_-]/gi,"_")+suffix;
  document.body.appendChild(link);link.click();link.remove();setTimeout(()=>URL.revokeObjectURL(url),1000);
}
export const downloadManualSeniors=(items,olderIds,label)=>downloadCSV(manualSeniorsCSV(items,olderIds),label,"-manual-seniors.csv");
export const downloadAllSeniors=(items,label)=>downloadCSV(allSeniorsCSV(items),label,"-all-seniors.csv");
